import { CellData } from '../../../../../../common/table/TableTypes';
import { getRawTextFromCellContentString } from '../../../../../../common/table/utils/tableCellContentStringUtils';
import { getCellRenderValue } from './tableCellRenderValueUtils';

/**
 * Returns the value that table search should match against for a persisted cell.
 */
export const getTableCellSearchValue = (cellData: CellData | undefined, locale: string): string | number => {
    if (!cellData || !cellData.value) return '';

    // Legacy untyped cells can still store Draft.js payloads in `value`, so search needs their raw text.
    if (!cellData.type && cellData.resultValue === undefined) {
        return getRawTextFromCellContentString(cellData.value);
    }

    return getCellRenderValue(cellData, locale, cellData.resultValue ?? null);
};
